import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { LookoButton, LookoModal, VStack } from '@looko-design-system';
import { Typography } from '@mui/material';

import { useBoolean } from '@looko-corp/acloset-react-kit/src/react';

import { useShopInfo2 } from '@/app/shop/shop-info/hooks';

/**
 * 차단된 샵을 컨트롤 하는 Guard
 */
export default function BlockedShopGuard({ children }: { children: React.ReactNode }) {
  const { value: isOpenModal, setFalse: closeModal, setTrue: openModal } = useBoolean();

  const location = useLocation();

  const { shopInfo } = useShopInfo2();

  React.useEffect(() => {
    if (!!shopInfo.blockedDate && !location.pathname.includes('/my-page')) {
      openModal();
    }
  }, [location.pathname, openModal, shopInfo.blockedDate]);

  if (!!shopInfo.blockedDate && !location.pathname.includes('/my-page')) {
    return <Navigate to="/my-page" state={{ from: location }} replace />;
  }

  return (
    <>
      <NotificationModal isOpen={isOpenModal} closeModal={closeModal} />
      {children}
    </>
  );
}

function NotificationModal({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) {
  return (
    <LookoModal onClose={closeModal} open={isOpen}>
      <LookoModal.Header>Looko-AI 솔루션 계정 비활성화</LookoModal.Header>
      <LookoModal.Content>
        <VStack width={707} gap={2}>
          <Typography variant="Subtitle_Looko">
            부적절한 계정 사용으로 인하여 계정이 비활성화되었습니다. 비활성화 계정은 아래 중 1개 이상을 위반하였을 때
            발생할 수 있습니다.
          </Typography>

          <ul style={{ padding: '0px 30px', margin: 0 }}>
            <li>
              <Typography variant="Body_Looko">
                세컨솔드 플랫폼으로 부적절한 상품 또는 테스트 상품을 반복적으로 게시하는 경우
              </Typography>
            </li>
            <li>
              <Typography variant="Body_Looko">세컨솔드 고객들의 주문에 대응을 반복적으로 하지 않는 경우</Typography>
            </li>
            <li>
              <Typography variant="Body_Looko">
                세컨솔드 고객들에게 앱 내 구매시 불이익을 주거나, 다른 쇼핑몰 / 플랫폼에서의 구매를 유도하는 경우
              </Typography>
            </li>

            <li>
              <Typography variant="Body_Looko">정상적인 쇼핑몰을 운영하는 계정이 아닌 것으로 보이는 경우</Typography>
            </li>

            <li>
              <Typography variant="Body_Looko">그 외 부정한 방식으로 솔루션을 사용하는 경우</Typography>
            </li>
          </ul>

          <Typography variant="Body_Looko">
            계정 활성화를 희망하시는 경우,
            <strong>
              <u>business@acloset.app</u>
            </strong>
            으로 사업자명, 사업자번호, 솔루션 사용 목적, 연락처를 기입하여 메일을 보내주세요.
          </Typography>

          <Typography variant="Body_Looko">
            감사합니다.
            <br />
            룩코팀 드림
          </Typography>
        </VStack>
      </LookoModal.Content>

      <LookoModal.Actions>
        <LookoButton onClick={closeModal}>확인</LookoButton>
      </LookoModal.Actions>
    </LookoModal>
  );
}
